import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';
import { BackEndService } from 'src/app/backend-service';
import { IIssueTransactionView } from '../../../interfaces';
import { STEP_FORM_GROUP } from '../../dialog/issue-transaction-dialog2/issue-transaction-dialog2-component-classes';

@Component({
  selector: 'app-pdf-preview',
  templateUrl: './pdf-preview.component.html',
  styleUrls: ['./pdf-preview.component.css']
})
export class PdfPreviewComponent implements IIssueTransactionView, OnInit {

  downloading: boolean = false;
  downloadSucceeded: boolean = false;
  downloadFailed: boolean = false;
  wrongSetup: boolean = false;
  objectUrl: BehaviorSubject<SafeResourceUrl> = new BehaviorSubject(null);

  constructor(
    @Inject(STEP_FORM_GROUP) public formGroup: FormGroup,
    private _backEndService: BackEndService,
    private _snackBar: MatSnackBar,
    private _sanitizer: DomSanitizer
  ) { }

  loadFile() {
    if(this.urlControl.value){
      this.downloading = true;
      this.wrongSetup = false;
      this
        ._backEndService
        .getBlob(this.urlControl.value)
        .subscribe(
          result => {
            this.objectUrl.next(this._sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(result)));
            this.downloadSucceeded = true;
            this.downloadFailed = false;
            this.downloading = false;
          },
          error => {
            this._snackBar.open(`Die Vorschau konnte nicht erstellt werden da ein Fehler aufgetreten ist. (${error.message})`, "Download", {
              'duration': 6000
            } as MatSnackBarConfig);
            this.downloadSucceeded = false;
            this.downloadFailed = true;
            this.downloading = false;
          }
        );
    } else this.wrongSetup = true;
  }

  ngOnInit(): void {
    this.loadFile();
    console.log(this.formGroup.value);
  }

  get urlControl(): AbstractControl {
    return this.formGroup.controls['url'];
  }

}
